import * as React from "react";
import { MoneyTextBoxEditor } from "../../../../../../../../react-core/Html/Money/MoneyTextBoxEditor";
import { MoneyDisplayHelper } from "../../../../../../../../react-core/Helpers/MoneyDisplayHelper";
import { RadiosEditor } from "../../../../../../../../react-core/Html/RadiosEditor";
import { CurrencyCode } from "../../../../../../../../Wrap/Constants/Enums/Domain/CurrencyCode";
import { quoteSippIncomePaymentDetailsLabels, quoteSippIncomePaymentDetailsMessages } from "../../../Resource/Content";
import PayeEstimate from "../../../../Common/SIPP/IncomePaymentDetails/PayeEstimate";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../../Shared/Process/Process/ProcessComponent";
import {
    calculateMaximumGrossOneOffIncomePaymentWithStandardAlgorithm,
    calculateMaximumGrossOneOffIncomePaymentWithTargetAlgorithm,
} from "../../../../Common/SIPP/IncomePaymentDetails/Helper/IncomePaymentHelper";
import { processTypeEnum } from "../../../../Common/Resource/Contents";
import { PensionBase } from "../../../../../../../../Wrap/Models/Models/QuoteAndApplyBase/PensionBase";
import { OneOffTaxableWithdrawalDetails } from "../../../../../../../../Wrap/Models/Domains/Drawdown/OneOffTaxableWithdrawalDetails";

interface IOneOffIncomePaymentProps extends IProcessComponentProps {
    data: OneOffTaxableWithdrawalDetails;
    onChange: (changes) => void;
    pensionBase: PensionBase;
    isITFC: boolean;
}
interface IOneOffIncomePaymentState {
    isOneOffPayment: boolean;
}

export class OneOffIncomePayment extends ProcessComponent<IOneOffIncomePaymentProps, IOneOffIncomePaymentState> {
    constructor(props: any) {
        super(props);
        this.state = {
            isOneOffPayment: this.isTakeOneOffIncomePayment(props.data),
        };
    }

    private handleChange(changes) {
        const { data, onChange } = this.props;
        this.onDataChange(onChange, changes, data);
    }

    private isTakeOneOffIncomePayment(oneOffPayment) {
        return oneOffPayment !== null;
    }

    componentDidMount() {
        const { data } = this.props;
        super.componentDidMount();
        if (data?.Amount == null || data?.Amount?.Amount == 0) {
            this.setState({ isOneOffPayment: false });
        }
    }

    public render(): JSX.Element {
        const { data, pensionBase, isITFC } = this.props;

        const labels = quoteSippIncomePaymentDetailsLabels;
        const messages = quoteSippIncomePaymentDetailsMessages;

        const isTarget =
            pensionBase?.DrawdownModel?.Income?.TargetSpecificArrangements ||
            pensionBase?.PensionTransfers[0]?.IncomePaymentDetails?.DrawdownIncome?.AnnualIncome
                ?.TargetSpecificArrangements;

        return (
            <>
                <h3>{labels.oneOffIncomePayment}</h3>

                <RadiosEditor
                    cssWrapper="rg-inline mb-16"
                    label={labels.takeOneOffIncomePayment}
                    selected={this.state.isOneOffPayment}
                    options={[true, false]}
                    getText={(v) => (v ? "Yes" : "No")}
                    onChange={(v) => {
                        this.setState({ isOneOffPayment: v });
                        this.handleChange({
                            Amount: null,
                        });
                    }}
                />
                {this.state.isOneOffPayment && (
                    <>
                        <div className="row">
                            <span className="col-sm-6 h4">{labels.maximumGrossOneOffIncomePayment}</span>
                            <span className="col-sm-6 pl-0" data-test="maximumGrossOneOffIncomePayment">
                                {isTarget == false
                                    ? MoneyDisplayHelper.FromatMoneyDisplay(
                                          calculateMaximumGrossOneOffIncomePaymentWithStandardAlgorithm(
                                              processTypeEnum.Quote,
                                              pensionBase,
                                              isITFC
                                          ),
                                          CurrencyCode.GBP
                                      )
                                    : MoneyDisplayHelper.FromatMoneyDisplay(
                                          calculateMaximumGrossOneOffIncomePaymentWithTargetAlgorithm(
                                              processTypeEnum.Quote,
                                              pensionBase,
                                              isITFC
                                          ),
                                          CurrencyCode.GBP
                                      )}
                            </span>
                        </div>

                        <div className="row">
                            <div className="col-12 col-md-4">
                                <MoneyTextBoxEditor
                                    label={labels.oneOffIncomePayment}
                                    value={data?.Amount?.Amount}
                                    currency={data?.Amount?.Currency || CurrencyCode.GBP}
                                    onChange={(v) =>
                                        this.handleChange({
                                            Amount: {
                                                Amount: v,
                                                Currency: CurrencyCode.GBP,
                                            },
                                        })
                                    }
                                    required={messages.oneOffIncomePaymentRequired}
                                    atMost={{
                                        errorMessage: messages.grossOneOffIncomePerPaymentOver,
                                        value: calculateMaximumGrossOneOffIncomePaymentWithStandardAlgorithm(
                                            processTypeEnum.Quote,
                                            pensionBase,
                                            isITFC
                                        ),
                                    }}
                                    validationRules={[
                                        {
                                            errorMessage: "Please enter an amount that is greater than zero.",
                                            validator: (v) => v > 0,
                                        },
                                    ]}
                                />
                            </div>
                        </div>

                        <PayeEstimate data={null} onClick={() => {}} labels={labels} messages={messages} />
                    </>
                )}
            </>
        );
    }
}

export default OneOffIncomePayment;
